import { render } from "./SupplierFollowUp.vue?vue&type=template&id=ff3191ae"
import script from "./SupplierFollowUp.vue?vue&type=script&lang=js"
export * from "./SupplierFollowUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__